import { Button, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import AbsHistory from "../../abstract/History";
import { useApp } from "../../contexts/AppContext";
import { CycleData } from "./types";

const StyledTableContainer = styled(TableContainer)({
  border: "1px solid #E7E5E4",
  borderRadius: "8px",
  backgroundColor: "white",
  "& .MuiTableCell-root": {
    borderBottom: "1px solid #E7E5E4",
    fontSize: 18,
  },
});

const StyledTableRow = styled(TableRow)({
  "&:last-child td, &:last-child th": {
    // border: 0,
  },
});

const StyledTableHead = styled(TableHead)({
  "& th": {
    fontSize: 18,
  },
});

const data: CycleData[] = [
  {
    cycleId: "1",
    cycleDate: "2023-01-01",
    patientName: "John Doe",
    recommendedProtocol: "Protocol A",
    predictedOocytes: 10,
    oocytes: 8,
    predirectedOocytes: 0,
    actualOutcome: "Successful",
  },
  {
    cycleId: "2",
    cycleDate: "2023-02-15",
    patientName: "Jane Smith",
    recommendedProtocol: "Protocol B",
    predictedOocytes: 12,
    oocytes: 10,
    predirectedOocytes: 5,
    actualOutcome: "Review required",
  },
  {
    cycleId: "3",
    cycleDate: "2023-03-20",
    patientName: "Alice Johnson",
    recommendedProtocol: "Protocol C",
    predictedOocytes: 8,
    oocytes: 6,
    predirectedOocytes: 5,
    actualOutcome: "Unsuccessful",
  },
  {
    cycleId: "4",
    cycleDate: "2023-04-15",
    patientName: "Bob Brown",
    recommendedProtocol: "Protocol D",
    predictedOocytes: 15,
    oocytes: 14,
    predirectedOocytes: 0,
    actualOutcome: "Successful",
  },
  {
    cycleId: "5",
    cycleDate: "2023-05-10",
    patientName: "Carol White",
    recommendedProtocol: "Protocol E",
    predictedOocytes: 9,
    oocytes: 7,
    predirectedOocytes: 8,
    actualOutcome: "Unsuccessful",
  },
];

const History: React.FC = () => {
  const { updateActions, updateBreadcrumbs } = useApp();
  const navigate = useNavigate();

  const handleOpenItem = (row: CycleData) => {
    navigate(`/hormone/${row.cycleId}`);
  };

  useEffect(() => {
    updateActions([
      <Button
        key="create"
        color="blackButton"
        onClick={() => navigate("/hormone/create")}
      >
        {" "}
        + Add New Cycle
      </Button>,
    ]);
    updateBreadcrumbs([
      {
        label: "Hormonal Protocol",
        onClick: () => {
          navigate("/hormone");
        },
      },
    ]);

    return () => {
      updateActions([]);
      updateBreadcrumbs([]);
    }
  }, []);

  const theme = useTheme();

  return (
    <AbsHistory<CycleData>
      title={"Hormonal Protocol Cycle Overview"}
      columns={[
        { id: "cycleId", label: "Cycle ID", sortable: true },
        { id: "patientName", label: "Patient Name", sortable: true },
        { id: "cycleDate", label: "Cycle Date", sortable: true },
        { id: "recommendedProtocol", label: "Recommended Protocol" },
        { id: "predirectedOocytes", label: "Predirected Oocytes Retrieved" },
        { id: "oocytes", label: "Actual Oocytes Retrieved" },
      ]}
      data={data}
      onItemClick={handleOpenItem}
    />
  );
};

export default History;
